import {
    RESERVE_EMPLOYEES_ALL_FETCHING,
    RESERVE_EMPLOYEES_ALL_FAILED,
    RESERVE_EMPLOYEES_ALL_SUCCESS
} from "../actions/types";

const initialState = {
    result: null,
    isFetching: false,
    isError: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case RESERVE_EMPLOYEES_ALL_FETCHING:
            return { ...state, result: null, isFetching: true, isError: false };
        case RESERVE_EMPLOYEES_ALL_FAILED:
            return { ...state, result: null, isFetching: false, isError: true };
        case RESERVE_EMPLOYEES_ALL_SUCCESS:
            return { ...state, result: payload, isFetching: false, isError: false };
        default:
            return state;
    }
};
